import { type FC } from "react";

import { useRecoilValue } from "recoil";

import { useFeatureGates } from "../../../cof-feature-gates/hooks";
import {
    defaultOrganizationContainerSelector,
    organizationsLoadingState,
    organizationsSelector,
} from "../../../core/recoil/organizations";
import { CofConfigId } from "../../../gql-generated/types";
import { useSelectedOrganizationContainer } from "../../../shared/hooks";
import { useOrganizationsV2 } from "../../../shared/hooks/useOrganizationsV2";

import { LensContainersPopover } from "./LensContainersPopover";

export const LensContainersDropdownV3: FC = () => {
    const { loading: isFeatureGatesLoading, configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;
    const { organizationContainers } = useRecoilValue(organizationsSelector);
    const orgsLoading = useRecoilValue(organizationsLoadingState);
    const defaultOrganizationContainer = useRecoilValue(defaultOrganizationContainerSelector);
    const {
        loading: loadingV2,
        organizations: organizationContainersV2,
        defaultOrganizationContainer: defaultOrganizationContainerV2,
    } = useOrganizationsV2();

    const { organizationName } = useSelectedOrganizationContainer();

    if (isFeatureGatesLoading) {
        return null;
    }

    if (isMyLensesOrgsV2Enabled) {
        if (loadingV2) {
            return null;
        }

        return (
            <LensContainersPopover
                organizationContainers={organizationContainersV2}
                selectedOrganizationName={organizationName}
                defaultOrganizationName={defaultOrganizationContainerV2?.name}
            />
        );
    }

    if (orgsLoading) {
        return null;
    }

    return (
        <LensContainersPopover
            organizationContainers={organizationContainers}
            selectedOrganizationName={organizationName}
            defaultOrganizationName={defaultOrganizationContainer?.name}
        />
    );
};
